import { registerIcon } from "@paperviewpdf/viewer";

// Reference icon: chain link (from public/assets/svg/toolbar-reference.svg)
registerIcon("papercurveReference", {
  viewBox: "63 18 24 13",
  paths: [
    {
      d: "M75.75,27 L73.5,27 C73.086,27 72.75,26.66475 72.75,26.25 C72.75,25.83525 73.086,25.5 73.5,25.5 L75.75,25.5 C77.4045,25.5 78.75,24.1545 78.75,22.5 C78.75,20.8455 77.4045,19.5 75.75,19.5 L67.5,19.5 C65.8455,19.5 64.5,20.8455 64.5,22.5 C64.5,24.1545 65.8455,25.5 67.5,25.5 C67.914,25.5 68.25,25.83525 68.25,26.25 C68.25,26.66475 67.914,27 67.5,27 C65.01825,27 63,24.98175 63,22.5 C63,20.01825 65.01825,18 67.5,18 L75.75,18 C78.23175,18 80.25,20.01825 80.25,22.5 C80.25,24.98175 78.23175,27 75.75,27 Z M82.5,30.75 L74.25,30.75 C71.76825,30.75 69.75,28.73175 69.75,26.25 C69.75,23.76825 71.76825,21.75 74.25,21.75 L76.5,21.75 C76.91475,21.75 77.25,22.086 77.25,22.5 C77.25,22.914 76.91475,23.25 76.5,23.25 L74.25,23.25 C72.5955,23.25 71.25,24.5955 71.25,26.25 C71.25,27.9045 72.5955,29.25 74.25,29.25 L82.5,29.25 C84.1545,29.25 85.5,27.9045 85.5,26.25 C85.5,24.5955 84.1545,23.25 82.5,23.25 C82.08525,23.25 81.75,22.914 81.75,22.5 C81.75,22.086 82.08525,21.75 82.5,21.75 C84.98175,21.75 87,23.76825 87,26.25 C87,28.73175 84.98175,30.75 82.5,30.75 Z",
      fill: "primary",
      stroke: "none",
    },
  ],
});

// Pin icon: map pin outline (from Papercurve v2 public/assets/svg/default-pin.svg)
registerIcon("papercurvePin", {
  viewBox: "0 0 18 18",
  paths: [
    {
      d: "M9 18C8.63438 18 8.29238 17.8161 8.08313 17.5129L8.00944 17.4077L3.56963 9.15356C3.07406 8.2485 2.8125 7.22306 2.8125 6.1875C2.8125 2.77594 5.58844 0 9 0C12.4116 0 15.1875 2.77594 15.1875 6.1875C15.1875 7.22306 14.9254 8.24962 14.4293 9.15525L9.99056 17.4077L9.9135 17.5168C9.70425 17.8178 9.36394 18 9 18ZM8.95781 16.7962L9.0045 16.8666L13.4404 8.61862C13.8482 7.87444 14.0625 7.03463 14.0625 6.1875C14.0625 3.39638 11.7917 1.125 9 1.125C6.20888 1.125 3.9375 3.39638 3.9375 6.1875C3.9375 7.03519 4.15181 7.875 4.55738 8.61525L4.55962 8.61919L8.95781 16.7962Z",
      fill: "primary",
      stroke: "none",
    },
  ],
});

// Claim icon: document with checkmark circle (from public/assets/svg/claims-icon.svg)
registerIcon("papercurveClaim", {
  viewBox: "0 0 22 22",
  paths: [
    {
      d: "M1 18.9566V3.38672",
      stroke: "primary",
      fill: "none",
    },
    {
      d: "M16.7207 20.5004H3.21664C3.21664 20.5004 1.92711 20.4784 1.36961 19.9421C1.16323 19.742 1 19.2634 1 19.0039",
      stroke: "primary",
      fill: "none",
    },
    {
      d: "M15.9924 1H2.66932C1.75111 1 1 1.72745 1 2.61595V3.03779C1 3.92634 1.75115 4.65375 2.66932 4.65375H16.7207V8",
      stroke: "primary",
      fill: "none",
    },
    {
      d: "M15.2097 1C15.2097 1 13.5445 2.94114 15.991 4.65379",
      stroke: "primary",
      fill: "none",
    },
    {
      d: "M20.5015 14.3312C20.5015 16.7233 18.5513 18.6624 16.1453 18.6624C13.7394 18.6624 11.7891 16.7233 11.7891 14.3312C11.7891 11.9392 13.7394 10 16.1453 10C18.5513 10 20.5015 11.9392 20.5015 14.3312Z",
      stroke: "primary",
      fill: "none",
    },
    {
      d: "M14.7639 14.0602L15.7822 15.178L17.6454 13.2977",
      stroke: "primary",
      fill: "none",
    },
  ],
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.15,
});
